import script from "./acquaint-nav-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./acquaint-nav-menu.vue?vue&type=script&setup=true&lang=ts"

import "./acquaint-nav-menu.vue?vue&type=style&index=0&id=2ddd2a3a&lang=scss"

const __exports__ = script;

export default __exports__